module.exports = __webpack_public_path__ + "img/shky.c9b21cb4.png";